export default __webpack_public_path__ + "static/media/icon-3.c9e7065d.png";